import { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { CbAnimationEnterExit } from '../..';
export interface AnimationStageProps {
  Logo: FC;
}
const AnimationStageEnter: FC<AnimationStageProps> = ({
  Logo
}) => {
  return <motion.div style={{
    position: 'relative'
  }} animate={{
    translateY: '0vh'
  }} initial={{
    translateY: '25vh'
  }} transition={{
    duration: 0.7,
    delay: 0.4
  }} data-sentry-element="unknown" data-sentry-component="AnimationStageEnter" data-sentry-source-file="CbLoginLogoAnimation.tsx">
      <Flex alignItems="center" justifyContent="center" marginTop={10} marginBottom={2} data-sentry-element="Flex" data-sentry-source-file="CbLoginLogoAnimation.tsx">
        <Flex alignItems="center" justifyContent="center" borderRadius="100px" paddingX={8} paddingY={5} data-sentry-element="Flex" data-sentry-source-file="CbLoginLogoAnimation.tsx">
          {Logo && <Logo />}
        </Flex>
      </Flex>
    </motion.div>;
};
const AnimationStageExit: FC<AnimationStageProps> = ({
  Logo
}) => {
  return <motion.div style={{
    position: 'relative'
  }} animate={{
    translateY: '20vh'
  }} initial={{
    translateY: '0vh'
  }} transition={{
    duration: 0.7
  }} data-sentry-element="unknown" data-sentry-component="AnimationStageExit" data-sentry-source-file="CbLoginLogoAnimation.tsx">
      <Flex alignItems="center" justifyContent="center" marginTop={10} marginBottom={2} data-sentry-element="Flex" data-sentry-source-file="CbLoginLogoAnimation.tsx">
        <Flex alignItems="center" justifyContent="center" backgroundColor="chonky.600" borderRadius="100px" paddingX={8} paddingY={5} data-sentry-element="Flex" data-sentry-source-file="CbLoginLogoAnimation.tsx">
          {Logo && <Logo />}
        </Flex>
      </Flex>
    </motion.div>;
};
export interface CbLoginLogoAnimationProps {
  animate: boolean;
  Logo: FC;
}
export const CbLoginLogoAnimation: FC<CbLoginLogoAnimationProps> = ({
  animate,
  ...props
}) => {
  return <CbAnimationEnterExit animate={animate} enterContent={<AnimationStageEnter {...props} />} exitContent={<AnimationStageExit {...props} />} data-sentry-element="CbAnimationEnterExit" data-sentry-component="CbLoginLogoAnimation" data-sentry-source-file="CbLoginLogoAnimation.tsx" />;
};